import { render, staticRenderFns } from "./nm-table.vue?vue&type=template&id=73332f52"
import script from "./nm-table.vue?vue&type=script&lang=js"
export * from "./nm-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports